export default __webpack_public_path__ + "static/media/single_panna.c09adc8c.png";